type MatchTouple<T> = [boolean, () => T];
type Match<T> = MatchTouple<T>[];

/**
 * match
 *
 * This function receives a series of touples, each containing a condition and a
 * function. If the condition is true, the function is executed and its return
 * value is returned. If no condition is true, an error is thrown.
 *
 * @param toMatch Touple of condition and function [boolean, () => T]
 * @returns a value of type T
 *
 * @example
 *
 * const value = match(
 * 	[condition1, () => value1],
 * 	[condition2, () => value2],
 * 	[condition3, () => value3],
 * );
 */
export const match = <T>(...toMatch: Match<T>): T => {
	for (const [condition, action] of toMatch) {
		if (condition) {
			return action();
		}
	}
	throw new Error('No match found');
};
